import {NotificationService} from "../../services/NotificationService";
import {ReaderService} from "../../services/ReaderService";
import {ServerStatusService} from "../../services/ServerStatusService";
import {Reader} from "../../entities/Reader";
import {ServerStatus} from "../../entities/ServerStatus";
import {ApplicationSetting} from "../../entities/ApplicationSetting";
import {ApplicationSettingService} from "../../services/ApplicationSettingService";

export class NetworkStatusCtrl {
    serverStatuses:ServerStatus[];
    readers:Reader[];
    serverStatusGridOptions: any = null;
    readerStatusGridOptions: any = null;
    intervalPromise:any;
    public static $inject = ['$scope', '$q', '$interval', 'ServerStatusService', 'ReaderService', 'ApplicationSettingService', 'NotificationService'];

    constructor(public $scope:any, public $q:ng.IQService, public $interval:ng.IIntervalService,
                public serverStatusService:ServerStatusService,
                public readerService:ReaderService,
                public applicationSettingService:ApplicationSettingService,
                public notifyService:NotificationService) {
        $scope.vm = this;
        console.log("******** Network Status Ctrl");
        var dateFilter = ApplicationSetting.applicationSetting.dateFormat;
        if(dateFilter === null)
            dateFilter = "MM-dd-yyyy HH:mm:ss";
        this.serverStatusGridOptions = {
            paginationPageSizes: [10, 15, 20, 50, 100, 200, 300, 400],
            paginationPageSize: 500,
            useExternalPagination: false,
            useExternalSorting: false,
            columnDefs: [
                {field: 'name', name: 'Name', width: 200,
                    cellClass: function(grid:any, row:any, col:any, rowRenderIndex:number, colRenderIndex:number) {
                        if (row.entity.isRecentlyActive())
                            return 'green';
                        else
                            return 'red';
                    }
                },
                {field: 'serverType', name: 'Server Type', width: 200,
                    cellClass: function (grid: any, row: any, col: any, rowRenderIndex: number, colRenderIndex: number) {
                        if (row.entity.isRecentlyActive())
                            return 'green';
                        else
                            return 'red';
                    }
                },

                {field: 'version', name: 'Version', width: 200,
                    cellClass: function(grid:any, row:any, col:any, rowRenderIndex:number, colRenderIndex:number) {
                        if (row.entity.isRecentlyActive())
                            return 'green';
                        else
                            return 'red';
                    }},
                {field: 'lastSeen', name: 'Last Seen', width: 200, cellFilter: "date:'" + dateFilter + "'",
                    cellClass: function(grid:any, row:any, col:any, rowRenderIndex:number, colRenderIndex:number) {
                        if (row.entity.isRecentlyActive())
                            return 'green';
                        else
                            return 'red';
                    }
                },                
            ],
            data: this.serverStatuses,
        };
        this.readerStatusGridOptions = {
            paginationPageSizes: [10, 15, 20, 50, 100, 200, 300, 400, 500, 1000, 2000],
            paginationPageSize: 500,
            useExternalPagination: false,
            useExternalSorting: false,
            columnDefs: [
                {field: 'name', name: 'Name', width: 200,
                    cellClass: function(grid:any, row:any, col:any, rowRenderIndex:number, colRenderIndex:number) {
                        if (row.entity.isRecentlyActive())
                            return 'green';
                        else
                            return 'red';
                    }},
                {field: 'lastSeen', name: 'Last Seen', width: 200, cellFilter: "date:'" + dateFilter + "'",
                    cellClass: function(grid:any, row:any, col:any, rowRenderIndex:number, colRenderIndex:number) {
                        if (row.entity.isRecentlyActive())
                            return 'green';
                        else
                            return 'red';
                    }},
                {field: 'useWithService', name: 'Use With Service', width: 200,
                    cellClass: function(grid:any, row:any, col:any, rowRenderIndex:number, colRenderIndex:number) {
                        if (row.entity.isRecentlyActive())
                            return 'green';
                        else
                            return 'red';
                    }},
            ],
            data: this.readers,
        };
        $scope.$on('$destroy',()=> {
            $interval.cancel(this.intervalPromise);
        });
        this.intervalPromise = this.$interval(function(test:any){
            $scope.vm.refreshData()
        },5000);
        this.refreshData();
    }
    refreshData(){
        //console.log("refresh.data this null?"+(this==null));
        this.$q.all([this.serverStatusService.getAll(), this.readerService.getServerReaders()]).then((data)=>{
            this.serverStatuses = data[0];
            this.serverStatusGridOptions.data = data[0];
            this.readers = data[1];
            this.readerStatusGridOptions.data = data[1];
        })
        .catch((exc)=>{
            this.notifyService.notifyError("Problem refreshing data", exc);
        })
    }
}

class Point{
    constructor(public x:number, public y:number){
    }
}
